// Mock data for Stand With Jamaica landing page

export const siteData = {
  siteName: "Stand With Jamaica",
  tagline: "Fair Pay, Better Health & Leadership Reform",
  heroHeadline: "Stand With Jamaica",
  heroSubheadline: "Help Us End Cheap Labour, Over-Taxation & Systemic Neglect — Support Jamaican Workers & Families Today",
  donateUrl: "https://gofundme.com/f/help-jamaican-workers-achieve-stability/fb/o?utm_medium=customer&utm_source=copy_link&utm_campaign=natman_sharesheet_dash&utm_content=amp14_t2&ts=1777337837708&attribution_id=sl:82902cef-9f44-4ccf-839c-28a8d1653888",
  
  stats: [
    { value: "2010-2030", label: "Years of Economic Hardship" },
    { value: "1000s", label: "BPO Workers Affected" },
    { value: "$0", label: "Fair Wage Increase" },
    { value: "100%", label: "Community Dedication" }
  ],
  
  issues: [
    {
      id: 1,
      title: "Underpaid Workers in BPO & Service Sectors",
      description: "Jamaica's growing BPO industry has created thousands of jobs — but too often at wages that don't match the cost of living or global contributions.",
      icon: "Briefcase"
    },
    {
      id: 2,
      title: "Over-Taxation Burdens",
      description: "For many citizens, tax rates and fees absorb a disproportionate share of their income, leaving little for basic needs, education, or health expenses.",
      icon: "Receipt"
    },
    {
      id: 3,
      title: "Healthcare & Leadership Gaps",
      description: "Persistent weaknesses in the healthcare system have made it harder for people to access care, manage chronic illness, and thrive — while leadership accountability has lagged behind.",
      icon: "HeartPulse"
    },
    {
      id: 4,
      title: "A Future of Promise, Not Poverty",
      description: "We believe in a Jamaica where work is valued, families are secure, and leadership prioritizes health, fairness, and prosperity for all.",
      icon: "Sunrise"
    }
  ],
  
  campaignGoals: [
    "Support affected workers and families struggling with low wages and high living costs.",
    "Provide resources for health and wellness access where systems have fallen short.",
    "Advocate for fair labour policies, transparent leadership, and equitable taxation that protects citizens.",
    "Educate communities on economic rights and long-term sustainability."
  ],
  
  donationUses: [
    {
      id: 1,
      title: "Emergency Family Support",
      description: "Direct assistance for families in crisis facing immediate financial hardship.",
      icon: "Heart"
    },
    {
      id: 2,
      title: "Financial Literacy & Advocacy",
      description: "Training programs to empower workers with knowledge of their economic rights.",
      icon: "BookOpen"
    },
    {
      id: 3,
      title: "Health Support Programs",
      description: "Access to healthcare resources and wellness initiatives for underserved communities.",
      icon: "Stethoscope"
    },
    {
      id: 4,
      title: "Policy Reform Campaigns",
      description: "Awareness initiatives advocating for systemic change and leadership accountability.",
      icon: "Megaphone"
    }
  ],
  
  images: {
    hero: "https://images.unsplash.com/photo-1583166615346-edadc433eaa7?w=1920&q=80",
    workers: "https://images.unsplash.com/photo-1599928407261-9c4143401705?w=800&q=80",
    community: "https://images.unsplash.com/photo-1664199749900-5c441c38e4b9?w=800&q=80",
    support: "https://images.unsplash.com/photo-1729089049887-389a46c99546?w=800&q=80",
    unity: "https://images.unsplash.com/photo-1721059050924-eaf014837bd1?w=800&q=80"
  },
  
  contact: {
    email: "contact@standwithjamaica.live",
    phone: "18767779122",
    address: "Kingston, Jamaica"
  },
  
  socialLinks: [
    { platform: "Facebook", url: "#", icon: "Facebook" },
    { platform: "Twitter", url: "#", icon: "Twitter" },
    { platform: "Instagram", url: "#", icon: "Instagram" }
  ]
};
